var map = {
	"./template1": "ZqrT",
	"./template1.vue": "ZqrT",
	"./template101": "uWap",
	"./template101.vue": "uWap",
	"./template2": "ouBl",
	"./template2.vue": "ouBl",
	"./template3": "OT5L",
	"./template3.vue": "OT5L",
	"./template4": "NXUI",
	"./template4.vue": "NXUI",
	"./template5": "V8Xi",
	"./template5.vue": "V8Xi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Sugg";


//////////////////
// WEBPACK FOOTER
// ./src/components/invoice_templates/invoices_old ^\.\/template.*$
// module id = Sugg
// module chunks = 4